var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { ref: "frame", staticClass: "gift-card-page container" }, [
    _c(
      "div",
      { staticClass: "product-section", attrs: { "aria-hidden": "true" } },
      [
        _c("img", {
          staticClass: "product-image-skeleton no_cache",
          attrs: { src: _vm.smallProductImage, alt: _vm.selectedProductTitle },
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "product-image no_cache",
          attrs: {
            src: _vm.backgroundProductImage,
            alt: _vm.selectedProductTitle,
          },
          on: { load: _vm.handleImageLoad },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "overlay" }, [
          _c("img", {
            staticClass: "gift-card-logo",
            attrs: { src: _vm.theme.images.wf_logo },
          }),
          _vm._v(" "),
          _c("p", [
            _vm._v("A gift for you!"),
            _c("br"),
            _vm._v(
              "You have received a " +
                _vm._s(
                  _vm.selectedVariant ? _vm.selectedVariant.title : "Gift Card"
                ) +
                " White Fox e-Gift card"
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "card",
              staticClass: "rounded-image-container",
              class: {
                sparkle: !_vm.selectedProduct.tags.includes("no_sparkle"),
              },
            },
            [
              _c("img", {
                staticClass: "rounded-image-skeleton no_cache",
                attrs: {
                  src: _vm.smallProductImage,
                  alt: _vm.selectedProductTitle,
                },
              }),
              _vm._v(" "),
              _c("img", {
                ref: "roundedContainer",
                staticClass: "rounded-image no_cache",
                attrs: {
                  src: _vm.selectedProductImage,
                  alt: _vm.selectedProductTitle,
                },
                on: { load: _vm.handleImageLoad },
              }),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "message" }, [
            _vm.showRecipientName
              ? _c("p", [_vm._v("Hey, " + _vm._s(_vm.recipientName))])
              : _vm._e(),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.recipientMessage))]),
            _vm._v(" "),
            _vm.showSenderName
              ? _c("p", [_vm._v("From " + _vm._s(_vm.senderName))])
              : _vm._e(),
          ]),
        ]),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "gift-card-selection" }, [
      _c(
        "form",
        {
          staticClass: "gift-card-form",
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.handleSubmit.apply(null, arguments)
            },
          },
        },
        [
          _vm.formError
            ? _c(
                "div",
                {
                  staticClass: "form-error",
                  attrs: { role: "alert", "aria-live": "polite" },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.formError) +
                      "\n            "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.formSuccess
            ? _c(
                "div",
                {
                  staticClass: "form-success",
                  attrs: { role: "alert", "aria-live": "polite" },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.formSuccess) +
                      "\n            "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "gift-card-header" }, [
            _c("h1", { attrs: { "aria-label": "E-Gift Card" } }, [
              _vm._v("E-Gift Card"),
            ]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.giftCardIntro))]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "rounded-image-container-mob",
              class: {
                sparkle: !_vm.selectedProduct.tags.includes("no_sparkle"),
              },
            },
            [
              _c("img", {
                staticClass: "rounded-image-skeleton no_cache",
                attrs: {
                  src: _vm.smallProductImage,
                  alt: _vm.selectedProductTitle,
                },
              }),
              _vm._v(" "),
              _c("img", {
                ref: "roundedContainer",
                staticClass: "rounded-image no_cache",
                attrs: {
                  src: _vm.selectedProductImage,
                  alt: _vm.selectedProductTitle,
                },
                on: { load: _vm.handleImageLoad },
              }),
            ]
          ),
          _vm._v(" "),
          _c("fieldset", { staticClass: "gift-card-steps" }, [
            _c("legend", { staticClass: "gift-card-steps-header" }, [
              _vm._v("1. Choose a design"),
            ]),
            _vm._v(" "),
            _vm.products && _vm.products.length
              ? _c(
                  "div",
                  { staticClass: "gift-card-designs" },
                  _vm._l(
                    _vm.products.filter((p) => p.title !== "Gift Card"),
                    function (product) {
                      return _c(
                        "label",
                        {
                          key: product.id,
                          staticClass: "product-label",
                          class: {
                            active:
                              _vm.selectedProduct &&
                              _vm.selectedProduct.id === product.id,
                          },
                          attrs: {
                            "aria-selected":
                              _vm.selectedProduct &&
                              _vm.selectedProduct.id === product.id,
                          },
                        },
                        [
                          _c("input", {
                            staticClass: "hidden-radio",
                            attrs: {
                              type: "radio",
                              name: "product_id",
                              required: "",
                              "aria-label": `Select gift card design: ${product.title}`,
                            },
                            domProps: {
                              value: product.id,
                              checked:
                                _vm.selectedProduct &&
                                _vm.selectedProduct.id === product.id,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.selectProduct(product)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("img", {
                            staticClass: "gift-card-image",
                            attrs: {
                              src: product.featured_image,
                              alt: `Gift card design: ${product.title}`,
                            },
                          }),
                        ]
                      )
                    }
                  ),
                  0
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("fieldset", { staticClass: "gift-card-steps" }, [
            _c("legend", { staticClass: "gift-card-steps-header" }, [
              _vm._v(
                "\n                    2. Choose an amount \n                    "
              ),
              _vm.convertedPrice
                ? _c("small", [_vm._v(_vm._s(_vm.convertedPrice))])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _vm.products && _vm.selectedProduct
              ? _c(
                  "div",
                  { staticClass: "gift-card-denominations" },
                  _vm._l(_vm.selectedProduct.variants, function (variant) {
                    return _c(
                      "label",
                      {
                        key: variant.id,
                        staticClass: "gift-card-denomination-label",
                        class: {
                          active:
                            _vm.selectedVariant &&
                            _vm.selectedVariant.id === variant.id,
                        },
                      },
                      [
                        _c("input", {
                          staticClass: "hidden-radio",
                          attrs: {
                            type: "radio",
                            name: "variant_id",
                            id: "price",
                            required: "",
                            "aria-label": "Select gift card amount:",
                          },
                          domProps: {
                            value: variant.id,
                            checked:
                              _vm.selectedVariant &&
                              _vm.selectedVariant.id === variant.id,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.selectVariant(variant)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "gift-card-denomination-amount" },
                          [_vm._v(_vm._s(_vm.formatTitle(variant.title)))]
                        ),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("fieldset", { staticClass: "gift-card-steps" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "personalise-accordion-content" }, [
              _c("div", { staticClass: "recipient-fields__field" }, [
                _c("label", { attrs: { for: "recipient-email" } }, [
                  _vm._v("Their Email"),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.recipientEmail,
                      expression: "recipientEmail",
                    },
                  ],
                  attrs: {
                    type: "email",
                    id: "recipient-email",
                    placeholder: "Recipient's Email",
                  },
                  domProps: { value: _vm.recipientEmail },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.recipientEmail = $event.target.value
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "recipient-names-row" }, [
                _c("div", { staticClass: "recipient-fields__field" }, [
                  _c("label", { attrs: { for: "recipient-name" } }, [
                    _vm._v("Their Name"),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.recipientName,
                        expression: "recipientName",
                      },
                    ],
                    attrs: {
                      type: "text",
                      id: "recipient-name",
                      placeholder: "Their Name",
                    },
                    domProps: { value: _vm.recipientName },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.recipientName = $event.target.value
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "recipient-fields__field" }, [
                  _c("label", { attrs: { for: "sender-name" } }, [
                    _vm._v("Your Name"),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.senderName,
                        expression: "senderName",
                      },
                    ],
                    attrs: {
                      type: "text",
                      id: "sender-name",
                      placeholder: "Your Name",
                    },
                    domProps: { value: _vm.senderName },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.senderName = $event.target.value
                      },
                    },
                  }),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "recipient-fields__field" }, [
                _c("label", { attrs: { for: "recipient-message" } }, [
                  _vm._v("Message"),
                ]),
                _vm._v(" "),
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.recipientMessage,
                      expression: "recipientMessage",
                    },
                  ],
                  attrs: {
                    id: "recipient-message",
                    placeholder: "Personal Message",
                    maxlength: "200",
                    rows: "4",
                  },
                  domProps: { value: _vm.recipientMessage },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.recipientMessage = $event.target.value
                    },
                  },
                }),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary product__add-to-cart d-block w-100",
              attrs: { type: "submit" },
            },
            [_vm._v("+ Add to Bag ")]
          ),
          _vm._v(" "),
          _vm.defaultProduct
            ? _c("div", {
                staticClass: "gift-card-product-description",
                domProps: { innerHTML: _vm._s(_vm.defaultProduct.description) },
              })
            : _vm._e(),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "gift-card-steps-header-container" }, [
      _c("legend", { staticClass: "gift-card-steps-header" }, [
        _vm._v("\n                        3. Personalise your card "),
        _c("small", [_vm._v("(optional)")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }